<template>
  <div>
    <!-- 配送单待出货 -->
    <baseBreadcrumb
      :page="$t('message.deliveryOrderToBeShipped')"
      :menu="$t('message.porder')"
    />

    <porderBaseTable :status="50" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>